import React from "react";

export default function TequilaFrame1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-teq1{fill:#bae2e2}.cls-teq2{fill:#f7e06b}.cls-teq3{fill:#d6dd45}.cls-teq4{fill:#e3f251}.cls-teq5{fill:#caedef}.cls-teq6{fill:#eff}.cls-teq9{fill:#f3da37}.cls-teq12{fill:#ffeb99}"
            }
          </style>
        </defs>
        <path
          d="M1601.88 1813.16H387.26c-81.36 0-147.55-66.19-147.55-147.55V450.99c0-81.36 66.19-147.55 147.55-147.55h1214.62c81.36 0 147.55 66.19 147.55 147.55v1214.62c0 81.36-66.19 147.55-147.55 147.55ZM387.26 338.44c-62.06 0-112.55 50.49-112.55 112.55v1214.62c0 62.06 50.49 112.55 112.55 112.55h1214.62c62.06 0 112.55-50.49 112.55-112.55V450.99c0-62.06-50.49-112.55-112.55-112.55H387.26Z"
          className="cls-teq9"
        />
        <path
          d="M1799 1522.63c8.37-147.19 50.12-264.75 85.34-341.84h-387.89c35.22 77.1 76.98 194.65 85.34 341.84 5.71 100.39-5.71 186.76-20.21 253.19h257.62c-14.5-66.42-25.92-152.79-20.21-253.19Z"
          className="cls-teq5"
        />
        <path
          d="M1796.38 1406.63c-35.72 151.23-17.33 267.73-85.62 295-1.72.69-31.28 12.02-58.79 0-63.78-27.88-35.47-145.96-65.18-292.05-11.16-54.9-34.63-134.02-90.34-226.25 35.32 77.35 76.99 194.86 85.34 341.84 5.71 100.39-5.71 186.76-20.21 253.19h257.62c-14.5-66.42-25.92-152.79-20.21-253.19 8.37-147.19 50.12-264.75 85.34-341.84-51.18 91.79-75.35 169.94-87.96 223.31Z"
          className="cls-teq1"
        />
        <ellipse
          cx={1690.4}
          cy={1183.32}
          className="cls-teq1"
          rx={193.94}
          ry={53.44}
        />
        <ellipse
          cx={1690.4}
          cy={1180.79}
          className="cls-teq6"
          rx={168.05}
          ry={37.24}
        />
        <path
          d="M1823.13 1811.44a468.892 468.892 0 0 1-131.54 19.18c-55.84.14-101.87-9.72-133.92-19.18v-62.21c0-12.76 11.41-22.45 24.01-20.46a695.51 695.51 0 0 0 103.53 8.54c42.84.32 81.21-3.36 113.99-8.55 12.57-1.99 23.94 7.74 23.94 20.47v62.21Z"
          className="cls-teq5"
        />
        <path
          d="M1792.82 1749.93c-6.56 47.41-10.23 59.42-12.41 59.27-3.89-.26-2.13-39.14-16.77-43.61-5.48-1.67-10.23 2.3-18.81-.59-5.61-1.88-9.48-5.7-11.94-8.79 8.12.66 17.87.84 28.83-.21 12.19-1.17 22.68-3.56 31.1-6.08Z"
          className="cls-teq6"
        />
        <path
          d="M1823.14 1759.46v13.42c0-12.73-11.37-22.46-23.94-20.47-32.78 5.2-71.15 8.87-113.99 8.55-38.55-.29-73.33-3.75-103.52-8.54-12.6-2-24.01 7.7-24.01 20.46v-13.42c0-12.76 11.41-22.46 24.01-20.46 30.19 4.79 64.98 8.25 103.52 8.55 42.84.32 81.21-3.36 113.99-8.55 12.58-2 23.94 7.73 23.94 20.47Z"
          className="cls-teq1"
        />
        <path
          d="M1676.25 1377.52c-37.25.82-69.02 6.77-93.56 13.29 5.12 20.64 12.1 52.55 16.73 92.01 15.21 129.49-14.92 183.15 20.6 217.39 34.97 33.71 106.92 36.51 141.85 5.11 36.47-32.78 2.04-91.37 19.5-222.5 5.04-37.84 12.48-68.49 18.05-88.64-29.47-8.79-71.89-17.79-123.18-16.66Z"
          className="cls-teq9"
        />
        <ellipse
          cx={1690.97}
          cy={1391.57}
          className="cls-teq2"
          rx={108.28}
          ry={23}
        />
        <path
          d="M1694.46 1414.56c-14.76 2.85-38.42 5.36-66.16-.82a160.783 160.783 0 0 1-38.07-13.72c12.46 4.45 27.62 8.8 45.12 11.68 22.94 3.77 43.15 3.91 59.1 2.86ZM1721.42 1383.56c-.48 3.88-27.53 3.43-39.64 2.8-12.53-.65-39.36-3.07-39.43-6.99-.06-3.39 19.93-7.92 39.43-6.99 20.18.96 40.06 7.79 39.64 11.18Z"
          className="cls-teq12"
        />
        <path
          d="M1769.87 1658.03c1.82.71-2.38 43.93-30.67 56.87-14.99 6.86-32.56 3.29-32.91.64-.36-2.72 17.63-2.73 34.82-15.02 23.28-16.63 27.31-43.05 28.75-42.49Z"
          className="cls-teq2"
        />
        <ellipse
          cx={1744.79}
          cy={1677.39}
          className="cls-teq2"
          rx={11.05}
          ry={8.47}
          transform="rotate(-60 1744.782 1677.389)"
        />
        <ellipse
          cx={1627.37}
          cy={1534.07}
          className="cls-teq2"
          rx={8.63}
          ry={63.9}
        />
        <path
          d="M1799.43 1227.51c-25.08 1.44-50.17 2.88-75.25 4.31.47 45.98.93 91.96 1.4 137.94 7.04.32 14.65.94 22.72 1.99 8.64 1.12 16.64 2.59 23.94 4.22 7.29-52.11 16.57-101.65 27.19-148.46Z"
          className="cls-teq1"
        />
        <path
          d="M1726.02 1413.34c.88 86.25 1.75 172.5 2.63 258.75 8.88-23.49 17.76-46.98 26.64-70.46.25-23.29.97-47.31 2.25-72.02 2.21-42.8 5.88-83.49 10.56-121.88a349.59 349.59 0 0 1-20.11 3.35 345.07 345.07 0 0 1-21.96 2.28Z"
          style={{
            fill: "#dbc03b",
          }}
        />
        <path
          d="M1768.09 1407.72c.63-5.17 1.28-10.39 1.97-15.63.71-5.42 1.43-10.79 2.18-16.11a269.07 269.07 0 0 0-22.66-4.05c-8.56-1.16-16.59-1.82-24-2.16.15 14.53.3 29.05.44 43.58 8.38-.53 17.33-1.44 26.78-2.88 5.31-.81 10.41-1.74 15.29-2.74Z"
          style={{
            fill: "#e0c968",
          }}
        />
        <path
          d="M1601.49 1291.25c-8.34 14.68-4.57 27.23-.43 64.42 5.98 53.78 5.59 97.01 3.63 97.24-2.5.3 1.56-70.54-34.58-147.89-19.41-41.55-44.1-71.49-36.99-78.31 5.62-5.4 22.36 12.59 58.79 21.73 38.19 9.58 68.8 2.1 69.65 7.03 1.01 5.84-43.62 6.84-60.06 35.78ZM1630.89 1723.84c-1.28 4.24-17.79 2.64-25.56 1.28-8.19-1.44-15.89-2.79-20.45-8.95-3.85-5.2-3.61-11.35-3.19-17.25 1.11-15.76 4.83-48.95 8.95-48.56 3.84.36-4.41 28.79 12.32 50.48 11.77 15.26 29.26 18.58 27.93 23Z"
          className="cls-teq6"
        />
        <path
          d="M740.41 403.62 128.99 582.48c-50.24-171.75 45.9-351.03 214.73-400.42 168.84-49.39 346.45 49.81 396.69 221.56Z"
          style={{
            fill: "#a1f238",
          }}
        />
        <path
          d="M709.59 412.63a3382.092 3382.092 0 0 1-319.8 105.76 3376.186 3376.186 0 0 1-228.6 54.67c-42.95-150.07 44.64-308.98 194.45-352.81 146.05-42.72 300.72 42.84 353.95 192.38Z"
          style={{
            fill: "#74a829",
          }}
        />
        <path
          d="M383.07 485.51c-.91 10.26-19.22 13.57-90.41 33.61-81.95 23.07-101.6 31.05-114.34 19.13-11.42-10.68-9.35-29.88-5.82-62.74 3.78-35.16 6.55-60.97 23.86-71.42 11.32-6.84 24.79-4.66 108.54 34.48 70.59 32.99 78.82 39.76 78.18 46.94Z"
          className="cls-teq4"
        />
        <path
          d="M383.07 485.51c-.92 10.26-19.22 13.57-90.42 33.6-81.95 23.08-101.6 31.05-114.34 19.13-11.42-10.67-9.35-29.89-5.82-62.74 3.78-35.16 6.54-60.96 23.86-71.42 1.4-.84 2.83-1.55 4.44-2.07-4.65 12.97-6.52 30.36-8.73 50.97-3.52 32.85-5.59 52.07 5.82 62.74 12.75 11.91 32.39 3.94 114.35-19.13 31.7-8.92 52.91-14.53 66.78-18.92 3.54 3.19 4.28 5.49 4.07 7.84Z"
          className="cls-teq3"
        />
        <path
          d="M405.08 451.34c-7.85 6.68-23.22-3.79-88.04-39.4-74.62-40.99-94.22-49.07-94.96-66.5-.66-15.62 14.28-27.87 39.82-48.83 27.34-22.43 47.4-38.89 67.08-34.22 12.87 3.06 20.95 14.05 53.25 100.67 27.22 73.01 28.35 83.6 22.85 88.28Z"
          className="cls-teq4"
        />
        <path
          d="M407.6 442.01c.5 5.39-.61 7.71-2.51 9.33-7.85 6.68-23.22-3.79-88.05-39.4-74.62-41-94.22-49.07-94.96-66.51-.66-15.61 14.27-27.87 39.82-48.83 24.57-20.16 43.26-35.49 61.07-35-11.43 6.27-23.86 16.48-38.34 28.35-25.54 20.96-40.48 33.21-39.83 48.83.74 17.44 20.34 25.51 94.97 66.51 34.54 18.97 55.03 30.81 67.84 36.72Z"
          className="cls-teq3"
        />
        <path
          d="M473.74 458.99c6.3 8.15 23.5 1.07 94.27-20.42 81.47-24.74 102.31-28.61 106.62-45.51 3.86-15.15-8.23-30.21-28.91-55.99-22.13-27.58-38.38-47.82-58.59-47.3-13.22.34-23.39 9.43-72.85 87.54-41.68 65.83-44.96 75.97-40.55 81.68Z"
          className="cls-teq4"
        />
        <path
          d="M675.03 391.17c-5.16-8.25-12.74-17.69-22.05-29.31-22.14-27.58-38.38-47.82-58.6-47.3-13.21.34-23.38 9.44-72.84 87.54-18.89 29.83-29.89 48.23-35.86 59.96-6.38.72-9.79-.29-11.94-3.06-4.41-5.71-1.13-15.84 40.55-81.68 49.46-78.11 59.63-87.21 72.84-87.54 20.22-.53 36.46 19.72 58.6 47.3 19.82 24.71 31.76 39.57 29.3 54.1Z"
          className="cls-teq3"
        />
        <path
          d="M436.77 442.07c10.21 1.4 17.51-15.71 52.93-80.64 40.77-74.75 52.92-92.11 44.15-107.2-7.86-13.51-27.05-15.78-59.86-19.67-35.12-4.16-60.89-7.21-74.95 7.33-9.19 9.51-10.07 23.12 9.41 113.5 16.41 76.17 21.18 85.7 28.33 86.68Z"
          className="cls-teq4"
        />
        <path
          d="M534.05 254.61c-9.82-2.66-22.65-4.19-38.8-6.09-35.12-4.16-60.88-7.21-74.95 7.33-9.18 9.51-10.07 23.13 9.41 113.5 7.46 34.6 12.51 55.44 16.47 67.99-3.47 3.86-6.31 5.16-9.43 4.74-7.15-.98-11.91-10.51-28.32-86.68-19.47-90.38-18.59-103.99-9.4-113.5 14.05-14.53 39.82-11.48 74.95-7.33 32.81 3.89 52 6.16 59.86 19.67.08.12.14.25.21.38Z"
          className="cls-teq3"
        />
        {children}
      </g>
    </svg>
  );
}
